import JustValidate from 'just-validate';
export class LoanRefinance {

	constructor() {
	}
	init() {
		const calculators = document.querySelectorAll('.calculator-section.type-loan_refinancing');
		if (!calculators) {
			return;
		}

		calculators.forEach(calculator => {
			const submitButton = calculator.querySelector('button[type=submit]');
			const form = calculator.querySelector('form');
			const validator = new JustValidate(form, {
				validateBeforeSubmitting: false,
			});
			validator.addField('#amount-financed', [
				{
					rule: 'required',
					errorMessage: 'Please enter an amount to be refinanced'
				},
				{
					rule: 'number',
					errorMessage: 'Please enter a valid number'
				},
				{
					rule: 'minNumber',
					value: 10000,
					errorMessage: 'The minimum amount is $10,000'
				}
			]);
			validator.addField('#current-payment', [
				{
					rule: 'required',
					errorMessage: 'Please enter a monthly payment amount'
				}
			]);
			validator.addField('#repayment-term', [
				{
					rule: 'required',
					errorMessage: 'Please select a term length'
				}
			]);
			validator.addField('#borrower-credit', [
				{
					rule: 'required',
					errorMessage: 'Please select a credit rating profile'
				}
			]);
			validator.onSuccess((e) => {
				const refiRates = window.MEFA_RATES;
				const refiAmount = calculator.querySelector('input[name=amount-financed]').value;
				const refiMonthly = calculator.querySelector('input[name=current-payment]').value;
				const refiIntType = 'fixed';//this was hidden in the original code
				const refiCreditP = calculator.querySelector('select[name=borrower-credit]').value;
				const refiPayNum = calculator.querySelector('select[name=repayment-term]').value;
				let refiIntRate = 0;

				switch (refiCreditP) {
					case 'fair':
						refiIntRate = refiIntType == 'fixed' ? refiRates[refiPayNum].ffair : refiRates[refiPayNum].vfair;
						break;
					case 'good':
						refiIntRate = refiIntType == 'fixed' ? refiRates[refiPayNum].fgood : refiRates[refiPayNum].vgood;
						break;
					case 'excellent':
						refiIntRate = refiIntType == 'fixed' ? refiRates[refiPayNum].felex : refiRates[refiPayNum].velex;
						break
				}

				const refiNewMnty = this.mefaRefiNewMonthlyPayment(refiIntRate, refiPayNum, refiAmount);
				calculator.querySelector('.placeholder-holder').classList.add('visually-hidden');

				//refinancing doesn't make sense
				if (parseFloat(refiMonthly) < parseFloat(refiNewMnty)) {
					// calculator.querySelector('.explanation-text').innerHTML = refiRates.mintxt;
					calculator.querySelector('.explanation').classList.remove('visually-hidden');
					calculator.querySelector('.results').classList.add('visually-hidden');
				}else{
					calculator.querySelector('.explanation').classList.add('visually-hidden');
					let years = refiPayNum / 12;
					// calculator.querySelector('.disclaimer').innerHTML = calculator.querySelector('.disclaimer').innerHTML.replace("{{term}}", years);
					if(calculator.querySelector('.disclaimer span')){
						calculator.querySelector('.disclaimer span').innerHTML = years;
					}
					calculator.querySelector('.disclaimer').classList.remove('visually-hidden');

					var mthSave = parseFloat(refiMonthly) - parseFloat(refiNewMnty);
					var annSave = mthSave.toFixed(2) * 12;

					calculator.querySelector('.value-fixed-apr').innerHTML = this.mefaPctNum(refiIntRate, 2);
					calculator.querySelector('.value-payment').innerHTML = this.mefaCommaNum(refiNewMnty.toFixed(2));
					calculator.querySelector('.value-savings').innerHTML = this.mefaCommaNum(mthSave.toFixed(2));
					calculator.querySelector('.value-savings-annual').innerHTML = this.mefaCommaNum(annSave.toFixed(2));

					this.renderGraph(calculator, refiMonthly, refiNewMnty);

					calculator.querySelector('.results').classList.remove('visually-hidden');
					const resultRect = calculator.querySelector('.results').getBoundingClientRect();
					if (resultRect.top < window.innerHeight && resultRect.bottom > 0) {
						return;
					}
					window.scrollTo({
						top: resultRect.top + window.pageYOffset - 100,
						behavior: 'smooth'
					});
				}

				calculator.querySelectorAll('input, select').forEach((el) => {
					el.addEventListener('change', () => {
						validator.revalidate();
					});
				});


			})
			validator.onFail((e) => {
				console.log("fail");
			});

		});

	}

	renderGraph(calculator,refiMonthly, refiNewMnty){
		var barChartTtl = parseFloat(refiMonthly) + parseFloat(refiNewMnty);
		var barChartOld = ((parseFloat(refiMonthly) / parseFloat(barChartTtl)) * 100);
		var barChartNew = ((parseFloat(refiNewMnty) / parseFloat(barChartTtl)) * 100);
		const barChartContainerHeight = 200;
		barChartOld = (barChartOld / 100) * barChartContainerHeight;
		barChartNew = (barChartNew / 100) * barChartContainerHeight;
		// if (Math.abs(parseInt(barChartOld)) > 80 || Math.abs(parseInt(barChartNew)) > 80) {
		// 	barChartOld = parseFloat(barChartOld) * 0.77;
		// 	barChartNew = parseFloat(barChartNew) * 0.77
		// }

		calculator.querySelector('.current-payment .amount').innerHTML = this.mefaCommaNum(parseFloat(refiMonthly).toFixed(2));
		calculator.querySelector('.current-payment .bar .bar-inner').style.height = parseFloat(barChartOld.toFixed(2)) + 'px';
		calculator.querySelector('.new-payment .amount').innerHTML = this.mefaCommaNum(parseFloat(refiNewMnty).toFixed(2));
		calculator.querySelector('.new-payment .bar .bar-inner').style.height = parseFloat(barChartNew.toFixed(2)) + 'px';
	}

	mefaRefiNewMonthlyPayment(refiIntRate, refiPayNum, refiAmount) {
		return -this.mefaPMT(this.mefaDecNumber(parseFloat(refiIntRate)) / 12, parseInt(refiPayNum), parseFloat(refiAmount), 0, 0).toFixed(2)
	}

	mefaPMT(rate_per_period, number_of_payments, present_value, future_value, type) {
		if (rate_per_period !== 0.0) {
			var q = Math.pow(1 + rate_per_period, number_of_payments);
			return -(rate_per_period * (future_value + (q * present_value))) / ((-1 + q) * (1 + rate_per_period * (type)))
		} else if (number_of_payments !== 0.0) {
			return -(future_value + present_value) / number_of_payments
		}
		return 0
	}

	mefaDecNumber(nIng) {
		return parseFloat(nIng) / 100
	}

	mefaCommaNum(nStr){
		nStr += '';
		var x = nStr.split('.');
		var x1 = x[0];
		var x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2')
		}
		return '$' + x1 + x2
	}

	mefaPctNum(nStr, decCount) {
		var nVal = this.mefaDecStrip(nStr);
		return parseFloat(nVal).toFixed(parseFloat(decCount)) + '%'
	}

	mefaDecStrip(nStr) {
		return nStr.replace(/[^0-9\.]+/g, '')
	}

}
